import gsap from 'gsap';
import throttle from 'lodash/throttle';
import query from 'dom-helpers/query';
import classes from 'dom-helpers/class';
import preload from 'preload-js';
import 'gsap/src/uncompressed/plugins/AttrPlugin';
import 'gsap/src/uncompressed/plugins/ColorPropsPlugin';
import config from '../pjax/config';
import { getDevice } from '../base/utils';
import Standard from './standard';
import Slideshow from '../components/slideshow';
import ScrollAnim from '../components/scroll-anim';
import Cursor from '../components/cursor';

class Home extends Standard {
    constructor(opt) {
        super(opt);
        this.slug = 'home';
        this.ui = null;
    }

    init(req, done) {
        this.queue = new preload.LoadQueue(false);
        this.queue.loadManifest(otherManifest, false);

        super.init(req, done);
    }

    dataAdded(done) {
        super.dataAdded();
        this.setImages();
        this.bindEvents();

        const InwindSlideshow = new Slideshow('#first-slider', {});
        const BelieveSlideshow = new Slideshow('#second-slider', {});

        InwindSlideshow.init();
        BelieveSlideshow.init();

        done();
    }

    bindEvents() {
        if (getDevice() !== 'base' && getDevice() !== 's-tablet') {
            const cursor = new Cursor();
            window.addEventListener('resize', throttle(this.setImages.bind(this), 500));
        }
    }

    setImages() {
        const images = query.querySelectorAll(this.page, '[data-ratio]');

        images.forEach((el) => {
            const w = el.clientWidth;
            const winH = window.innerHeight;
            const parent = el.parentNode;
            let ratio, heightBase, height;

            if (getDevice() === 'base' || getDevice() === 's-tablet') {
                const checkMobileRatio = el.getAttribute('data-ratio-mobile');
                const desktopRatio = parseFloat(el.getAttribute('data-ratio'));

                ratio = (checkMobileRatio !== null) ? parseFloat(checkMobileRatio) : desktopRatio;
            } else {
                ratio = parseFloat(el.getAttribute('data-ratio'));
            }

            heightBase = w * ratio;

            if (el.getAttribute('data-parallax') !== null) {
                const parallax = el.getAttribute('data-parallax');

                height = heightBase + (((winH - heightBase)) * Math.abs(parseFloat(parallax)));

                gsap.set(parent, {
                    height: heightBase,
                });
            } else {
                height = heightBase;
            }


            gsap.set(el, {
                height: height,
            });
        });
    }

    animateIn(req, done) {
        classes.addClass(config.$body, `is-${this.slug}`);

        const logo = this.view.querySelector('#logo');
        const filter = logo.querySelector('#slam');
        const paths = logo.querySelectorAll('.path');

        const introTl = new TimelineMax();
        const tl = new TimelineMax({
            onComplete: () => {
                const scroll = new ScrollAnim(this.page);
                classes.addClass(config.$body, 'is-loaded');
                classes.removeClass(config.$body, 'is-loading');
                done();
            },
        });

        introTl.set(this.page, {
            autoAlpha: 1,
        }).staggerTo(paths, 3, {
            y: 80,
            delay: 0.8,
            ease: Expo.easeOut,
        }, 0.25).set('.c-scroll', {
            className: '+=is-visible',
        }, '-=0.5');

        tl.to(filter.querySelector('#shadow-position'), 2, {
            attr: {
                dx: 6,
                dy: 6,
            },
            delay: 0.7,
            ease: gsap.Power0.easeNone,
        }).to(filter.querySelector('#flood'), 2, {
            attr: {
                'flood-opacity': '0.4',
            },
            delay: 0.8,
            ease: gsap.Power0.easeNone,
        }, '-=2');
    }

    animateOut(req, done) {
        classes.removeClass(config.$body, `is-${this.slug}`);

        gsap.to(this.page, 0.7, {
            autoAlpha: 0,
            ease: Expo.easeInOut,
            onComplete: done,
        });
    }

    destroy(req, done) {
        super.destroy();
        this.ui = null;
        this.page.parentNode.removeChild(this.page);
        done();
    }
}

module.exports = Home;

const base = '/assets/images/';
const otherImages = [
    'slider/believe1.jpg',
    'slider/believe2.jpg',
    'slider/believe3.jpg',
    'slider/believe4.jpg',
    'slider/believe5.jpg',
    'slider/believe6.jpg',
    'slider/believe7.jpg',
    'slider/believe8.jpg',
    'slider/inwind1.jpg',
    'slider/inwind2.jpg',
    'slider/inwind3.jpg',
    'slider/inwind4.jpg',
    'slider/inwind5.jpg',
    'slider/inwind6.jpg',
    'slider/inwind7.jpg',
    'slider/inwind8.jpg',
];

const otherManifest = otherImages.map((x) => `${base}${x}`);



/** WEBPACK FOOTER **
 ** ./sections/home.js
 **/